module.exports = __webpack_public_path__ + "img/TOP_220.df97d855.png";